import React from 'react'
import { canViewAgencyPage, isAssisting } from 'utils/pages'
import { PageDefinition, PageType } from 'pages/pageDefinition'
import { AuditComponent, AuditComponentProps } from 'components/audit'
import { WebAdminUser } from 'api'
import { usePageViewAudit } from 'hooks/usePageViewAudit'
import { useAuth } from 'hooks/useAuth'

const Route = {
  BaseRoute: '/audit',
  AssistedRoute:
    '/assist/customer/:customerAgencyId/agency/:licensedAgencyId/audit',
  BuildTemplate: (user: WebAdminUser | null) =>
    !isAssisting(user) ? [Route.BaseRoute] : [Route.AssistedRoute],
  BuildLink: (user: WebAdminUser | null) =>
    !isAssisting(user) || !user?.customerAgencyId || !user?.licensedAgencyId
      ? Route.BaseRoute
      : Route.AssistedRoute.replace(
          ':customerAgencyId',
          user.customerAgencyId,
        ).replace(':licensedAgencyId', user.licensedAgencyId),
}

const PageTitle = 'Audit Trail'
const buildPageTitle = (user: WebAdminUser | null) => {
  return !user?.licensedAgencyName
    ? PageTitle
    : `${user.licensedAgencyName} - ${PageTitle}`
}

const PageComponent: React.FunctionComponent<AuditComponentProps> = (props) => {
  const { user: authUser } = useAuth()
  usePageViewAudit(buildPageTitle(authUser), !!authUser)

  return <AuditComponent {...props} />
}

export const AuditPage: PageDefinition = {
  routes: Route.BuildTemplate,
  type: [PageType.Agency],
  sortOrder: () => 3,
  component: <PageComponent />,
  pageTitle: buildPageTitle,
  canAccess: canViewAgencyPage,
  navLinkText: PageTitle,
  buildNavLink: Route.BuildLink,
}
